export default __webpack_public_path__ + "static/media/5.f1967142.png";